import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import authReducer from './slices/authSlice'
import ordersReducer from './slices/ordersSlice'
import employeesReducer from './slices/employeesSlice'
import attendanceReducer from './slices/attendanceSlice'
import payrollReducer from './slices/payrollSlice'
import uiReducer from './slices/uiSlice'
import realtimeReducer from './slices/realtimeSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    orders: ordersReducer,
    employees: employeesReducer,
    attendance: attendanceReducer,
    payroll: payrollReducer,
    ui: uiReducer,
    realtime: realtimeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
})

// Setup listeners for RTK Query
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
